import { Button } from "@fronterahealth/frontera-ui-components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ExportTypeEnum } from "@api/graphql/types-and-hooks";
import { useCanExportDraft } from "@components/ReportReview/hooks/useCanExportDraft";
import { useDraftExport } from "@components/ReportReview/hooks/useDraftExport";

// Short labels keep the header menu compact.
const DRAFT_EXPORT_OPTIONS = [
  { id: ExportTypeEnum.Docx, label: "DOCX" },
  { id: ExportTypeEnum.Pdf, label: "PDF" },
];

export const DraftExportMenu: React.FC = () => {
  const canExportDraft = useCanExportDraft();
  const { exportDraft, isPending } = useDraftExport();

  if (!canExportDraft) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="outline" disabled={isPending}>
            {isPending ? "Exporting..." : "Export"}
          </Button>
        }
      />
      <DropdownMenuContent align="end" className="min-w-32 whitespace-nowrap">
        {DRAFT_EXPORT_OPTIONS.map((option) => (
          <DropdownMenuItem key={option.id} onClick={() => exportDraft(option.id)}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
